import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './routers'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/index'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import globalVariable from './api/global_variable'


Vue.config.productionTip = false

Vue.prototype.$http = axios
Vue.prototype.$video = Video //引入Video播放器
Vue.prototype.GLOBAL=globalVariable

//axios.defaults.baseURL = "http://49.235.164.72:911/api";
//添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('Authorization')) {
      config.headers.Authorization = localStorage.getItem('Authorization');
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  });

axios.interceptors.response.use(
  response => {
    //401未授权
    if (response.status === 401) {
      router.push({
        path: '/login',
        query: { redirect: router.history.current.fullPath }
      })
      //如果需要可以在这里将 vuex 里的 user 改为空对象
    }else{
      return response;
    }
  }, error => {
    //显示错误信息
    console.log(error.response);
    console.log(error);
    //获取用户信息的url需要授权，因为没有判断是否授权（过期没办法判断），所以就会跳到登录页面
    //这不好，希望的是在不需要登录的情况下也可以访问
    // && error.response.config.url!='/api/userauth/' && error.response.config.url.indexOf('/api/me')<0 && error.response.config.url!='/api/userauth/' && error.response.config.url.indexOf('/api/me')<0
    if(error.response.status==401){
      router.push({
        path: '/login',
        query: { redirect: router.history.current.fullPath }
      })
    }
    return Promise.reject(error.response.data)
  });

Vue.use(ElementUI);

new Vue({
  render: h => h(App),
  router,
  store: store,
}).$mount('#app')
